import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { ERROR_TEXT_COLOR } from "components/common/textColors";
import { VOTEBOX_FONT_WEIGHT_SEMIBOLD } from "./voteboxTokens";

type Props = {
    displayName: string;
};

export default function NoVoteAllowedMessage({ displayName }: Props) {
    const { t } = useTranslation();

    return (
        <NoVoteAllowed data-testid={`voter-${displayName}`}>
            {t("noAllowedToVote")}
        </NoVoteAllowed>
    );
}

const NoVoteAllowed = styled.p`
    color: ${ERROR_TEXT_COLOR};
    font-weight: ${VOTEBOX_FONT_WEIGHT_SEMIBOLD};
    margin-top: 10px;
`;
